module.exports = __webpack_public_path__ + "images/emoji/u7533.68710c177474f3c57926.png";